import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      goodMorning: 'Good Morning, {{name}}!',
      goodAfternoon: 'Good Afternoon, {{name}}!',
      goodEvening: 'Good Evening, {{name}}!',
      searchPlaceholder: 'Search here...',
      notifications: 'Notifications',
    },
  },
  es: {
    translation: {
      goodMorning: '¡Buenos días, {{name}}!',
      goodAfternoon: '¡Buenas tardes, {{name}}!',
      goodEvening: '¡Buenas noches, {{name}}!',
      searchPlaceholder: 'Buscar aquí...',
      notifications: 'Notificaciones',
    },
  },
  de: {
    translation: {
      goodMorning: 'Guten Morgen, {{name}}!',
      goodAfternoon: 'Guten Tag, {{name}}!',
      goodEvening: 'Guten Abend, {{name}}!',
      searchPlaceholder: 'Hier suchen...',
      notifications: 'Benachrichtigungen',
    },
  },
  fr: {
    translation: {
      goodMorning: 'Bonjour, {{name}}!',
      goodAfternoon: 'Bon après-midi, {{name}}!',
      goodEvening: 'Bonsoir, {{name}}!',
      searchPlaceholder: 'Rechercher ici...',
      notifications: 'Notifications',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n; // ✅ must export i18n instance
